export default theme => ({
  dialogRoot: {
    [theme.breakpoints.up('sm')]: {
      width: 420,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 5
    }
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    paddingBottom: 5,
  },
  content: {
    color: theme.palette.textColor.dark,
    '& .MuiDialogTitle-root': {
      padding: '5px 0',

      '& .MuiTypography-root': {
        fontSize: '14px',
        fontWeight: '300',
      }
    }
  },
  button: {
    margin: '0 auto',
    color: '#fff',
    background: theme.palette.primary.blue,
    '&:hover': {
      color: '#fff',
      background: '#1976D2! important',
    },
    '&:focus': {
      color: '#fff',
      background: `${theme.palette.primary.blue} !important`,
    }
  }
});
